import { Pressable, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { colors } from '@chillout/core'
import type { AdminSectionRoute, AdminSectionRouteName } from '../adminRoutes'

interface AdminMenuItemProps {
  isActive: boolean
  isFull: boolean
  onPress: (routeName: AdminSectionRouteName) => void
  route: AdminSectionRoute
}

export function AdminMenuItem({ isActive, isFull, onPress, route }: AdminMenuItemProps) {
  const { t } = useTranslation()
  const { Icon, name, navLabelKey } = route

  return (
    <Pressable
      onPress={() => onPress(name)}
      accessibilityLabel={t(navLabelKey)}
      accessibilityRole="menuitem"
      accessibilityState={{ selected: isActive }}
      className={
        isFull
          ? `-ml-3 -mr-4 mb-2 h-12 flex-row items-center gap-3 py-0 px-3 ${isActive ? 'rounded-md bg-inverse/10 border-r-[3px] border-accent' : 'rounded-md'}`
          : `mb-2 h-12 w-11 items-center justify-center rounded-md ${isActive ? 'bg-inverse/10 border-r-[3px] border-accent' : ''}`
      }
    >
      <View className={isFull ? 'w-5 shrink-0 items-center' : undefined}>
        <Icon
          size={20}
          color={isActive ? colors.text.inverse : 'rgba(255,255,255,0.55)'}
          strokeWidth={2}
        />
      </View>
      {isFull ? (
        <Text
          className={`whitespace-nowrap text-base font-semibold ${isActive ? 'text-inverse' : 'text-inverse/60'}`}
        >
          {t(navLabelKey)}
        </Text>
      ) : null}
    </Pressable>
  )
}
